import React, { useState } from "react";
import { Button, Form, Row, Col, Accordion, Table } from "react-bootstrap";
import locale from "../../../common/locale";
import Papa from "papaparse";

export default function UploadPIFileForm(props) {
  const [separatorsDict, setSeparatorsDict] = useState(null);

  if (
    props.postPI === undefined ||
    props.arraySepRef === undefined ||
    props.floatSepRef === undefined ||
    props.csvSep === undefined ||
    props.setCsvSep === undefined ||
    props.setCsvContent === undefined ||
    props.setFiles === undefined ||
    props.files === undefined ||
    props.csvContent === undefined
  )
    return "Loading";

  return (
    <Form onSubmit={props.postPI}>
      <Row style={{ paddingTop: 10 + "px" }}>
        <Col xxl={1} xl={2} lg={5} md={4} sm={3}>
          <Form.Group className="mb-3">
            <Form.Select
              aria-label="CSV Column Separator"
              value={props.csvSep}
              onChange={(e) => {
                e.preventDefault();
                props.setCsvSep(e.target.value);
              }}
            >
              <option value=",">,</option>
              <option value=";">;</option>
              <option value="-">-</option>
              <option value="\t">\t</option>
            </Form.Select>
            <Form.Text className="text-muted">Column separator</Form.Text>
          </Form.Group>
        </Col>
        <Col xxl={1} xl={2} lg={4} sm={3}>
          <Form.Group className="mb-3">
            <Form.Select
              aria-label="CSV Array separator"
              ref={props.arraySepRef}
            >
              <option value=";">;</option>
              <option value=",">,</option>
              <option value=".">.</option>
              <option value="-">-</option>
            </Form.Select>
            <Form.Text className="text-muted">Array separator</Form.Text>
          </Form.Group>
        </Col>
        <Col xxl={1} xl={2} lg={4} sm={3}>
          <Form.Group className="mb-3">
            <Form.Select
              aria-label="CSV Floating Point separator"
              ref={props.floatSepRef}
            >
              <option value=".">.</option>
              <option value=",">,</option>
            </Form.Select>
            <Form.Text className="text-muted">
              Floating Point separator
            </Form.Text>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col xxl={3} xl={4} lg={8} sm={6}>
          <Form.Control
            className="mb-3"
            type="file"
            accept=".csv"
            label="File"
            multiple
            onChange={(e) => {
              //bad selection
              if (
                e.target.files === null ||
                e.target.files === undefined ||
                e.target.files === ""
              ) {
                props.setFiles(null);
                props.setCsvContent(null);
                return;
              }
              props.setFiles(e.target.files);
              const _separatorsDict = {};  
              if (e.target.files.length === 1) {
                const _file = e.target.files[0];                
                Papa.parse(_file, {
                  preview: 11,
                  complete: function (results) {
                    _separatorsDict[_file.name] = results.meta.delimiter;

                    props.setCsvContent(results.data);
                  },
                });
              } else {
                Promise.all(
                  [...e.target.files].map(
                    (file) =>
                      new Promise((resolve, reject) => {
                        Papa.parse(file, {
                          preview: 2,
                          complete: function (results) {
                            _separatorsDict[file.name] = results.meta.delimiter;
                            resolve();
                          },
                        });
                      })
                  )
                ).then(() => {
                  setSeparatorsDict(_separatorsDict);
                });
              }
            }}
          />
        </Col>
      </Row>
      {props.csvContent !== null && (
        <Row>
          <Accordion
            style={{
              overflow: "scroll",
              //height: 70 + "vh",
              width: 28 + "vw",
              //width: 1200 + "px",
            }}
          >
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                {
                locale().preview + " - " + props.files[0].name}
              </Accordion.Header>
              <Accordion.Body>
                <Table responsive striped bordered hover>
                  <thead>
                    <tr>
                      {React.Children.toArray(
                        props.csvContent[0].map((h) => {
                          return <th>{h}</th>;
                        })
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {React.Children.toArray(
                      props.csvContent.slice(1).map((e) => {
                        return (
                          <tr>
                            {React.Children.toArray(
                              e.map((h) => {
                                return <td>{h}</td>;
                              })
                            )}
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Row>
      )}
      {separatorsDict !== null &&
        UnrollSeparatorsDict(separatorsDict, props.csvSep)}
      <Row>
        <Col>
          <Button variant="primary" type="submit">
            {locale().submit}
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

function UnrollSeparatorsDict(separatorsDict, csvSep) {
  return React.Children.toArray(
    Object.entries(separatorsDict)
      .filter(([filename, separator]) => separator !== csvSep)
      .map(([filename, separator]) => {
        return (
          <Row>
            <Col>
              <font
                style={{
                  marginLeft: 5 + "px",
                  color: "black",
                }}
              >
                Warning: the selected separator '{csvSep}' is different from the
                one detected in {filename} '{separator}
                '. Please check if everything is correct than submit the
                operation.
              </font>
            </Col>
          </Row>
        );
      })
  );
}
